module.exports = __webpack_public_path__ + "static/media/wowo-logo-full.0dbb243c.JPG";